import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticatedGuard } from 'routes/routes.guard';
import { RoutePaths, RouteRoles } from './route.roles';

const routes: Routes = [
    // {
    //     path: RoutePaths.Home,
    //     loadChildren: () => import('../modules/home/home.module').then((m) => m.HomeModule),
    // },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: RoutePaths.Login, // Update as needed
    },
    {
        path: RoutePaths.Classlink,
        loadChildren: () => import('../modules/classlink/classlink.module').then((m) => m.ClasslinkModule),
    },
    {
        path: RoutePaths.Classlink2,
        loadChildren: () => import('../modules/classlink/classlink.module').then((m) => m.ClasslinkModule),
    },
    {
        path: RoutePaths.Login,
        loadChildren: () => import('../modules/login/login.module').then((m) => m.LoginModule),
    },
    {
        path: RoutePaths.Home,
        loadChildren: () => import('../modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.Home },
    },
    {
        path: RoutePaths.Profile,
        loadChildren: () => import('../modules/profile/profile.module').then((m) => m.ProfileModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.Profile },
    },
    {
        path: RoutePaths.Reports,
        loadChildren: () => import('../modules/reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.Reports },
    },
    {
        path: RoutePaths.UserManagement,
        loadChildren: () => import('../modules/userseditor/userseditor.module').then((m) => m.UsersEditorModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.UserManagement },
    },
    {
        path: RoutePaths.SchoolImport,
        loadChildren: () => import('../modules/school-import/school-import.module').then((m) => m.SchoolImportModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.SchoolImport },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
